import React from "react";

const Header = () => {
  return <h2>Expense</h2>;
};

export default Header;
